export {default} from './video-preview';
